import React, { useEffect, useState } from "react";
import { WithHostUrl } from "@quintype/components";

import { getHeaderUrl } from "./utils";

export const useStyleMenubar = (isVerticalMenubar) => {
  useEffect(() => {
    const element = document.getElementsByTagName("body")[0];
    element.style.overflow = isVerticalMenubar ? "hidden" : "";
  }, [isVerticalMenubar]);
};

export const useDeviceWidth = (setIsDesktop) => {
  useEffect(() => {
    if (global.deviceWidth >= 876) {
      setIsDesktop(true);
    }
  }, []);
};

export const logoRenderer = (children, currentPath, pageType = "") => (
  <WithHostUrl>
    {({ currentHostUrl }) => {
      const hostUrl = () => {
        if (currentPath) {
          return getHeaderUrl(currentPath);
        } else if (currentHostUrl) {
          return currentHostUrl + "/";
        } else return "/";
      };
      return (
        <a aria-label="logo render link" href={hostUrl()}>
          {children}
        </a>
      );
    }}
  </WithHostUrl>
);

export const importScript = (src, attributes = {}, target = "body", pageType = "") => {
  useEffect(() => {
    if (window) {
      const script = document.createElement("script");
      script.src = src;
      for (const attribute in attributes) {
        script[attribute] = attributes[attribute];
      }
      document[target].appendChild(script);
      return () => {
        document[target].removeChild(script);
      };
    }
  }, [src, pageType]);
};

export const useAutoRefresh = (name) => {
  useEffect(() => {
    if (window) {
      let timeOut;
      let time = new Date().getTime();
      const updateActivityTime = () => {
        time = new Date().getTime();
      };
      document.addEventListener("scroll", updateActivityTime);
      const refresh = () => {
        if (new Date().getTime() - time >= 600000) {
          window.location.reload();
        } else {
          timeOut = setTimeout(refresh, 10000);
        }
      };
      timeOut = setTimeout(refresh, 10000);
      return () => {
        document.removeEventListener("scroll", updateActivityTime);
        clearTimeout(timeOut);
      };
    }
  }, [name]);
};

export const useM3widget = (section) => {
  const [m3widgets, setM3widgets] = useState(false);
  useEffect(() => {
    if (section === 22336) {
      setM3widgets(true);
    } else {
      setM3widgets(false);
    }
  }, [section]);
  return m3widgets;
};

export const useWRUwidget = (section) => {
  if (section === 17533 || section === 17704) {
    return true;
  } else {
    return false;
  }
};
